module.exports = __webpack_public_path__ + "static/media/Frame 2819.e82cf170.jpg";